/** Locale keys of the four phone messages, shared by the field-error presenter and the zod error map. */
export const PhoneMessageKey = {
  incomplete: 'presentation.errors.field.phoneIncomplete',
  invalid: 'presentation.errors.field.phoneInvalid',
  invalidCharacters: 'presentation.errors.field.phoneInvalidCharacters',
  required: 'presentation.errors.field.phoneRequired'
} as const
